import moment from 'moment';
import { put, call, select } from 'redux-saga/effects';
import {
  CAPICOM_CERT_INFO_ISSUER_SIMPLE_NAME, CAPICOM_CURRENT_USER_STORE, CAPICOM_MY_STORE, CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED,
} from '../constants';
import { initCadesStore, loadCadesStoreFailed, loadCadesStoreSuccessful } from '../actions';
import processError from '../../../utils/processError';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import CertificateAdjuster from '../../../utils/CertificateAdjuster';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';

export const getCadesState = state => {
  const {
    [SYSTEM_MODULE]: {
      cadesState = null,
    },
  } = state;
  return cadesState;
};

export function initCades(cadesState = null) {
  return new Promise(resolve => {
    if (!window.cadesplugin) {
      const script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', '/cadesplugin_api.js');
      script.onerror = () => {
        resolve({ isError: true, errorText: 'Ошибка подключения библиотеки.' });
      };
      script.onload = () => {
        window.cadesplugin.then(
          () => {
            resolve({ isError: false, errorText: '' });
          },
          error => {
            resolve({ isError: true, errorText: error });
          },
        );
      };
      document.getElementsByTagName('head')[0].appendChild(script);
    } else {
      // todo this need load cadesState from redux store
      resolve(cadesState);
    }
  });
}

export default function* loadCadesStore(action) {
  try {
    // todo need refactoring (initCades to outer file)
    const cadesState = yield select(getCadesState);
    const initData = yield initCades(cadesState);
    yield put(initCadesStore(initData));
    if (initData && initData.isError) {
      yield put(loadCadesStoreFailed());
      yield call(rejectActionPromise(action, {}));
      return;
    }
    const store = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.Store');
    store.Open(CAPICOM_CURRENT_USER_STORE, CAPICOM_MY_STORE, CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED);
    const certificates = yield store.Certificates;
    const certCnt = yield certificates.Count;
    const list = [];
    for (let i = 1; i <= certCnt; i++) {
      const cert = yield certificates.Item(i);
      const certDateFrom = yield cert.ValidFromDate;
      const certDateTo = yield cert.ValidToDate;
      const issuerInfo = yield cert.GetInfo(CAPICOM_CERT_INFO_ISSUER_SIMPLE_NAME);
      const ValidFromDate = new Date(certDateFrom);
      const ValidToDate = new Date(certDateTo);
      const subjectName = yield cert.SubjectName;
      const certificateAdjuster = new CertificateAdjuster();
      const thumbprint = yield cert.Thumbprint;
      // const privateKey = cert.PrivateKey();
      // const publicKey = yield cert.PublicKey;
      // const pk2 = yield publicKey();
      // const pk3 = yield pk2.EncodedKey;
      // const pk4 = yield pk3.Value();
      const certData = {
        cn: certificateAdjuster.extractWithOutWhatName(subjectName, 'CN='),
        city: certificateAdjuster.extractWithOutWhatName(subjectName, 'L='),
        organization: certificateAdjuster.extractWithOutWhatName(subjectName, 'O='),
        direction: certificateAdjuster.extractWithOutWhatName(subjectName, 'OU='),
        email: certificateAdjuster.extractWithOutWhatName(subjectName, 'E='),
        certFromDate: moment(ValidFromDate),
        certToDate: moment(ValidToDate),
        cert,
        issuerInfo,
        thumbprint,
      };
      list.push(certData);
    }

    yield put(loadCadesStoreSuccessful(list));
    yield call(resolveActionPromise(action, list));
    yield store.Close();
  } catch (e) {
    if (typeof e === 'string') {
      yield put(initCadesStore({ isError: true, errorText: `Ошибка получения сертификатов: ${window.cadesplugin.getLastError(e)}` }));
    }
    yield put(loadCadesStoreFailed());
    yield call(rejectActionPromise(action, {}));
    yield processError(e);
  }
}
